import { Controller } from "@hotwired/stimulus"

// Filters a list of model checkboxes by category + sex. Hidden rows get
// unchecked so they can't be submitted.
export default class extends Controller {
  static targets = ["category", "sex", "row", "empty"]

  filter() {
    const cat = this.hasCategoryTarget ? this.categoryTarget.value : ""
    const sex = this.hasSexTarget ? this.sexTarget.value : ""
    let visible = 0

    this.rowTargets.forEach((row) => {
      const matchCat = !cat || row.dataset.category === cat
      const matchSex = !sex || row.dataset.sex === sex
      const show = matchCat && matchSex
      row.style.display = show ? "" : "none"
      if (show) {
        visible += 1
      } else {
        const cb = row.querySelector("input[type=checkbox]")
        if (cb) cb.checked = false
      }
    })

    if (this.hasEmptyTarget) this.emptyTarget.style.display = visible === 0 ? "" : "none"
  }
}
